import { locationsOptions } from '@/_schemas/generic/locations';
import type { RouteListItem } from '@/types';

import type { InfrastructureFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues: Readonly<InfrastructureFormSchema> = {
  id: -1,
  name: '',
  location: { ...locationsOptions[0] },
  ip: '',
  country_id: -1,
  state_short_name: '',
  notes: '',
} as const;

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/infrastructures', name: 'Infrastructures' },
];
